// extracted by mini-css-extract-plugin
export var chevron = "_oz-1";
export var clickable = "_oz-0";
export var ruleRow = "_oz-2";